// Microsoft Clarity user identification.
//
// The Clarity loader (bootstrap/Providers.jsx) only injects the script when
// REACT_APP_CLARITY_ID is set (production), and the queueing shim it installs
// makes `window.clarity(...)` safe to call before the script finishes loading.
export const identifyClarityUser = (user, w = window) => {
  const userUuid = user?.userUuid
  if (!userUuid || typeof w.clarity !== 'function') {
    return false
  }
  w.clarity('identify', userUuid)
  w.clarity('set', 'user_uuid', userUuid)
  return true
}
